import { render, staticRenderFns } from "./PPT.vue?vue&type=template&id=191fcca6&scoped=true&lang=pug"
import script from "./PPT.js?vue&type=script&lang=js&external"
export * from "./PPT.js?vue&type=script&lang=js&external"
import style0 from "./PPT.vue?vue&type=style&index=0&id=191fcca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191fcca6",
  null
  
)

export default component.exports